<template>
  <div>
    <h4><b>Income</b></h4>
    <div class="mb-5">
      <div class="h5 ml-2">
        Registration Income
      </div>
      <div class="row row-header ml-4">
        <div class="col-4 col-header text-danger text-left">
          Title
        </div>
        <div class="col-3 col-header text-danger text-center">
          Budget
        </div>
        <div class="col-3 col-header text-danger text-center">
          Actual
        </div>
        <div class="col-2 col-header text-danger text-right">
          Difference
        </div>
      </div>
      <div
        class="row row-data ml-4"
        v-for="detail in budgetInfo.RegistrationIncome.Details"
        :key="detail.BudgetItemId"
      >
        <div class="col-3">
          {{ detail.Title }}
        </div>
        <div class="col-3 text-right">
          {{ budgetFormatter(detail) }}
        </div>
        <div class="col-1 pl-0 pr-0">
          {{ currencyFormatter(detail.ExtendedBudgetAmount) }}
        </div>
        <div class="col-2 text-right">
          {{ actualFormatter(detail) }}
        </div>
        <div class="col-2">
          {{ currencyFormatter(detail.ActualAmount) }}
        </div>
        <div class="col-1 text-right pl-0">
          {{ currencyFormatter(detail.BudgetRemaining) }}
        </div>
      </div>
    </div>
    <div class="mb-5">
      <div class="h5 ml-2">
        Other Income
      </div>
      <div class="row row-header ml-4">
        <div class="col-4 col-header text-danger text-left">
          Title
        </div>
        <div class="col-3 col-header text-danger text-center">
          Budget
        </div>
        <div class="col-3 col-header text-danger text-center">
          Actual
        </div>
        <div class="col-2 col-header text-danger text-right">
          Difference
        </div>
      </div>
      <div
        class="row row-data ml-4"
        v-for="detail in budgetInfo.OtherIncome.Details"
        :key="detail.BudgetItemId"
      >
        <div class="col-4">
          {{ detail.Title }}
        </div>
        <div class="col-3 text-right">
          {{ budgetFormatter(detail) }}
        </div>
        <div class="col-1">
          {{ currencyFormatter(detail.ExtendedBudgetAmount) }}
        </div>
        <div class="col-2 text-right">
          {{ actualFormatter(detail) }}
        </div>
        <div class="col-1">
          {{ currencyFormatter(detail.ActualAmount) }}
        </div>
        <div class="col-1 text-right">
          {{ currencyFormatter(detail.BudgetRemaining) }}
        </div>
      </div>
    </div>
    <h4><b>Expenses</b></h4>
    <div class="mb-5">
      <div class="h5 ml-2">
        Scouter Expenses
      </div>
      <div class="row row-header ml-4">
        <div class="col-4 col-header text-danger text-left">
          Title
        </div>
        <div class="col-3 col-header text-danger text-center">
          Budget
        </div>
        <div class="col-3 col-header text-danger text-center">
          Actual
        </div>
        <div class="col-2 col-header text-danger text-right">
          Difference
        </div>
      </div>
      <div
        class="row row-data ml-4"
        v-for="detail in budgetInfo.ScouterExpenses.Details"
        :key="detail.BudgetItemId"
      >
        <div class="col-4">
          {{ detail.Title }}
        </div>
        <div class="col-3 text-right">
          {{ budgetFormatter(detail) }}
        </div>
        <div class="col-1 pl-0 pr-0">
          {{ currencyFormatter(detail.ExtendedBudgetAmount) }}
        </div>
        <div class="col-2 text-right">
          {{ actualFormatter(detail) }}
        </div>
        <div class="col-1 pl-0 pr-0">
          {{ currencyFormatter(detail.ActualAmount) }}
        </div>
        <div class="col-1 text-right pl-0">
          {{ currencyFormatter(detail.BudgetRemaining) }}
        </div>
      </div>
    </div>
    <div class="mb-5">
      <div class="h5 ml-2">
        Administrative Expenses
      </div>
      <div class="row row-header ml-4">
        <div class="col-4 col-header text-danger text-left">
          Title
        </div>
        <div class="col-3 col-header text-danger text-center">
          Budget
        </div>
        <div class="col-3 col-header text-danger text-center">
          Actual
        </div>
        <div class="col-2 col-header text-danger text-right">
          Difference
        </div>
      </div>
      <div
        class="row row-data ml-4"
        v-for="detail in budgetInfo.AdminExpenses.Details"
        :key="detail.BudgetItemId"
      >
        <div class="col-4">
          {{ detail.Title }}
        </div>
        <div class="col-3 text-right">
          {{ budgetFormatter(detail) }}
        </div>
        <div class="col-1 pl-0 pr-0">
          {{ currencyFormatter(detail.ExtendedBudgetAmount) }}
        </div>
        <div class="col-2 text-right">
          {{ actualFormatter(detail) }}
        </div>
        <div class="col-1 pl-0 pr-0">
          {{ currencyFormatter(detail.ActualAmount) }}
        </div>
        <div class="col-1 text-right pl-0">
          {{ currencyFormatter(detail.BudgetRemaining) }}
        </div>
      </div>
    </div>
    <div class="mb-5">
      <div class="h5 ml-2">
        Consumable Expenses
      </div>
      <div class="row row-header ml-4">
        <div class="col-4 col-header text-danger text-left">
          Title
        </div>
        <div class="col-3 col-header text-danger text-center">
          Budget
        </div>
        <div class="col-3 col-header text-danger text-center">
          Actual
        </div>
        <div class="col-2 col-header text-danger text-right">
          Difference
        </div>
      </div>
      <div
        class="row row-data ml-4"
        v-for="detail in budgetInfo.Consumables.Details"
        :key="detail.BudgetItemId"
      >
        <div class="col-4">
          {{ detail.Title }}
        </div>
        <div class="col-3 text-right">
          {{ budgetFormatter(detail) }}
        </div>
        <div class="col-1 pl-0 pr-0">
          {{ currencyFormatter(detail.ExtendedBudgetAmount) }}
        </div>
        <div class="col-2 text-right">
          {{ actualFormatter(detail) }}
        </div>
        <div class="col-1 pl-0 pr-0">
          {{ currencyFormatter(detail.ActualAmount) }}
        </div>
        <div class="col-1 text-right pl-0">
          {{ currencyFormatter(detail.BudgetRemaining) }}
        </div>
      </div>
    </div>
    <div class="mb-5">
      <div class="h5 ml-2">
        Food Expenses
      </div>
      <div class="row row-header ml-4">
        <div class="col-4 col-header text-danger text-left">
          Title
        </div>
        <div class="col-3 col-header text-danger text-center">
          Budget
        </div>
        <div class="col-3 col-header text-danger text-center">
          Actual
        </div>
        <div class="col-2 col-header text-danger text-right">
          Difference
        </div>
      </div>
      <div
        class="row row-data ml-4"
        v-for="detail in budgetInfo.Food.Details"
        :key="detail.BudgetItemId"
      >
        <div class="col-4">
          {{ detail.Title }}
        </div>
        <div class="col-3 text-right">
          {{ budgetFormatter(detail) }}
        </div>
        <div class="col-1 pl-0 pr-0">
          {{ currencyFormatter(detail.ExtendedBudgetAmount) }}
        </div>
        <div class="col-2 text-right">
          {{ actualFormatter(detail) }}
        </div>
        <div class="col-1 pl-0 pr-0">
          {{ currencyFormatter(detail.ActualAmount) }}
        </div>
        <div class="col-1 text-right pl-0">
          {{ currencyFormatter(detail.BudgetRemaining) }}
        </div>
      </div>
    </div>
    <div class="mb-5">
      <div class="h5 ml-2">
        Contingency Reserve
      </div>
      <div class="row row-header ml-4">
        <div class="col-4 col-header text-danger text-left">
          Title
        </div>
        <div class="col-3 col-header text-danger text-center">
          Budget
        </div>
        <div class="col-3 col-header text-danger text-center">
          Actual
        </div>
        <div class="col-2 col-header text-danger text-right">
          Difference
        </div>
      </div>
      <div
        class="row row-data ml-4"
        v-for="detail in budgetInfo.Contingencies.Details"
        :key="detail.BudgetItemId"
      >
        <div class="col-4">
          {{ detail.Title }}
        </div>
        <div class="col-3 text-right">
          {{ budgetFormatter(detail) }}
        </div>
        <div class="col-1 pl-0 pr-0">
          {{ currencyFormatter(detail.ExtendedBudgetAmount) }}
        </div>
        <div class="col-2 text-right">
          {{ actualFormatter(detail) }}
        </div>
        <div class="col-1 pl-0 pr-0">
          {{ currencyFormatter(detail.ActualAmount) }}
        </div>
        <div class="col-1 text-right pl-0">
          {{ currencyFormatter(detail.BudgetRemaining) }}
        </div>
      </div>
    </div>
    <div class="mb-5">
      <div class="h5 ml-2">
        Other Expenses
      </div>
      <div class="row row-header ml-4">
        <div class="col-4 col-header text-danger text-left">
          Title
        </div>
        <div class="col-3 col-header text-danger text-center">
          Budget
        </div>
        <div class="col-3 col-header text-danger text-center">
          Actual
        </div>
        <div class="col-2 col-header text-danger text-right">
          Difference
        </div>
      </div>
      <div
        class="row row-data ml-4"
        v-for="detail in budgetInfo.OtherExpenses.Details"
        :key="detail.BudgetItemId"
      >
        <div class="col-4">
          {{ detail.Title }}
        </div>
        <div class="col-3 text-right">
          {{ budgetFormatter(detail) }}
        </div>
        <div class="col-1 pl-0 pr-0">
          {{ currencyFormatter(detail.ExtendedBudgetAmount) }}
        </div>
        <div class="col-2 text-right">
          {{ actualFormatter(detail) }}
        </div>
        <div class="col-1 pl-0 pr-0">
          {{ currencyFormatter(detail.ActualAmount) }}
        </div>
        <div class="col-1 text-right pl-0">
          {{ currencyFormatter(detail.BudgetRemaining) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatter from '@/services/formatter.js'

export default {
  name: 'ReportBudgetDetails',
  components: {
  },
  props: {
    budgetInfo: {
      type: Object,
      default: function () {
        return {
          Budget: {}
        }
      }
    }
  },
  data: function () {
    return {
      cellStyle: { padding: '0', height: '20px', 'font-size': '10px' },
      headerCellStyle: { padding: '0', height: '20px', 'font-size': '10px', 'word-break': 'normal' },
      loading: true,
      errormessage: null,
      scouterEstimate: {
        show: false,
        participants: null,
        staff: null
      },
      showEditItem: false,
      editItem: {},
      tempHolding: null
    }
  },
  methods: {
    currencyFormatter: function (value) {
      return formatter.formatAsCurrency(value, 2)
    },
    _currencyFormatter: function (row, column, cellValue, index) {
      return formatter.formatAsCurrency(cellValue, 2)
    },
    budgetFormatter: function (row) {
      let returnValue = ''

      switch (row.BudgetQuantityType) {
        case 'Participant':
          returnValue = this.budgetInfo.Budget.EstimatedParticipants + ' participants x ' + formatter.formatAsCurrency(row.BudgetAmount, 2)
          break
        case 'StaffMember':
          returnValue = this.budgetInfo.Budget.EstimatedStaff + ' staff members x ' + formatter.formatAsCurrency(row.BudgetAmount, 2)
          break
        case 'CourseDay':
          returnValue = '5 days x ' + formatter.formatAsCurrency(row.BudgetAmount, 2)
          break
        case 'Quantity':
          returnValue = row.BudgetQuantity + ' x ' + formatter.formatAsCurrency(row.BudgetAmount, 2)
          break
        case 'Scouter':
          var scouters = this.budgetInfo.Budget.EstimatedParticipants + this.budgetInfo.Budget.EstimatedStaff
          returnValue = scouters + ' scouters x ' + formatter.formatAsCurrency(row.BudgetAmount, 2)
          break
        default:
          break
      }
      return returnValue
    },
    actualFormatter: function (row) {
      let returnValue = ''

      switch (row.BudgetQuantityType) {
        case 'Participant':
          returnValue = this.budgetInfo.Budget.ParticipantCount + ' participants'
          break
        case 'StaffMember':
          returnValue = this.budgetInfo.Budget.StaffCount + ' staff members'
          break
        case 'Scouter':
          var scouters = this.budgetInfo.Budget.ParticipantCount + this.budgetInfo.Budget.StaffCount
          returnValue = scouters + ' scouters'
          break
        default:
          break
      }
      return returnValue
    },
    budgetMathFormatter: function (row, column, cellValue, index) {
      this.tempHolding = { r: row, c: column, cv: cellValue, i: index }
      let returnValue = ''

      switch (row.BudgetQuantityType) {
        case 'Participant':
          returnValue = this.budgetInfo.Budget.EstimatedParticipants + ' participants x ' + formatter.formatAsCurrency(row.BudgetAmount, 2)
          break
        case 'StaffMember':
          returnValue = this.budgetInfo.Budget.EstimatedStaff + ' staff members x ' + formatter.formatAsCurrency(row.BudgetAmount, 2)
          break
        case 'CourseDay':
          returnValue = '5 days x ' + formatter.formatAsCurrency(row.BudgetAmount, 2)
          break
        case 'Quantity':
          returnValue = row.BudgetQuantity + ' x ' + formatter.formatAsCurrency(row.BudgetAmount, 2)
          break
        case 'Scouter':
          var scouters = this.budgetInfo.Budget.EstimatedParticipants + this.budgetInfo.Budget.EstimatedStaff
          returnValue = scouters + ' scouters x ' + formatter.formatAsCurrency(row.BudgetAmount, 2)
          break
        default:
          break
      }
      return returnValue
    },
    actualMathFormatter: function (row, column, cellValue, index) {
      this.tempHolding = { r: row, c: column, cv: cellValue, i: index }
      let returnValue = ''

      switch (row.BudgetQuantityType) {
        case 'Participant':
          returnValue = this.budgetInfo.Budget.ParticipantCount + ' participants'
          break
        case 'StaffMember':
          returnValue = this.budgetInfo.Budget.StaffCount + ' staff members'
          break
        case 'Scouter':
          var scouters = this.budgetInfo.Budget.ParticipantCount + this.budgetInfo.Budget.StaffCount
          returnValue = scouters + ' scouters'
          break
        default:
          break
      }
      return returnValue
    }
  }
}
</script>
<style scoped>
.cell {
  word-break: normal !important;
}
</style>
